import apiClient from './_axios';

/**
 * Moving one MikroTik vendo between Cloud and MikroTik Hybrid.
 *
 * In a file of its own, not api/vendo: the Updates tab tests mock that module
 * with a fixed list of exports, and a new export there breaks every one of
 * them the moment the tab renders this.
 */
export type HybridMovePhase = 'awaiting-firmware' | 'cutting-over' | 'done' | 'failed';

export interface MikrotikHybridStatus {
   platform: string;
   /** What the vendo is running as right now. */
   mode: 'cloud' | 'hybrid';
   /** Platform admins only while this is in beta. The server enforces it. */
   canSwitch: boolean;
   /** Why "Switch to Hybrid" would be refused, in words to act on. */
   blocked: string | null;
   coinBoxOnline: boolean;
   coinFirmware: string | null;
   move: {
      direction: 'to-hybrid' | 'to-cloud';
      phase: HybridMovePhase;
      targetFirmwareVersion: string;
      startedAt: string | null;
      finishedAt: string | null;
      attempts: number;
      error: string | null;
   } | null;
}

export async function getMikrotikHybridStatus(deviceId: string): Promise<MikrotikHybridStatus> {
   const r = await apiClient.get<MikrotikHybridStatus>(`/vendo/devices/${deviceId}/local-first/status`);
   return r.data;
}

/** Prepares the move and returns; it completes when the NodeMCU reports in on the new firmware. */
export async function switchMikrotikToHybrid(deviceId: string): Promise<{ ok: boolean; phase?: HybridMovePhase }> {
   const r = await apiClient.post(`/vendo/devices/${deviceId}/local-first/migrate`, {});
   return r.data;
}

/** Back to Cloud. Also how a move to Hybrid that is still waiting is cancelled. */
export async function moveMikrotikBackToCloud(deviceId: string): Promise<{ ok: boolean; phase?: HybridMovePhase }> {
   const r = await apiClient.post(`/vendo/devices/${deviceId}/local-first/rollback`, {});
   return r.data;
}
